import React, { createContext, useState } from "react";
import {SuperOrder} from "@beeldit/ecommerce/super-orders/models/SuperOrder";

interface RequestInvoiceActionContextType {
  backendFormErrors: any;
  setBackendFormErrors: (backendFormErrors: any) => void;    
  element: SuperOrder;
  setElement: (element: any) => void;
  showModal: boolean;
  setShowModal: (showModal: boolean) => void;
}

export const RequestInvoiceActionContext = createContext<RequestInvoiceActionContextType>({
  backendFormErrors: {},
  setBackendFormErrors: () => {},  
  element: new SuperOrder(),
  setElement: () => {},
  showModal: false,
  setShowModal: () => {},

});

interface RequestInvoiceActionProviderProps {
  children: React.ReactNode;
}

export const RequestInvoiceActionProvider: React.FC<RequestInvoiceActionProviderProps> = ({
  children,
}) => {  
  const [backendFormErrors, setBackendFormErrors] = useState(null);
  const [element, setElement] = useState<SuperOrder>(new SuperOrder());
  const [showModal, setShowModal] = useState(false);

  const value = {    
    backendFormErrors,
    setBackendFormErrors,
    element,
    setElement,
    showModal,
    setShowModal,
  };
  return (
    <RequestInvoiceActionContext.Provider value={value}>
      {children}
    </RequestInvoiceActionContext.Provider>
  );
};
